export const ToolTypeEnum = Object.freeze({
	FEATURE_MATCHING_ASSESSMENT: "featureMatchingAssessment",
	ARE_QUESTIONNAIRE: "aREQuestionnaire",
	SCHEMA_THERAPY_CASE_CONCEPTUALIZATION_FORM: "schemaTherapyCaseConceptualizationForm",
	EFT_CASE_FORMULATION: "eftCaseFormulation",
	DECONSTRUCTION_QUESTIONS: "deconstructionQuestions",
	IMAGINAL_EXPOSURE_SCRIPT_WORKSHEET: "imaginalExposureScriptWorksheet",
	PATIENT_RULES_FOR_RITUAL_PREVENTION: "patientRulesForRitualPrevention",
	PRESENT_TRIGGER_WORKSHEET: "presentTriggerWorksheet",
	WHEEL_OF_LIFE: "wheelOfLife",
	HAPPINESS_SCALE: "happinessScale",
	GENOGRAM: "genogram",
	IFS_PARTS: "ifsParts",
	TIMELINE: "timeline",
	IPT_TIMELINE: "iptTimeline",
	READINESS_RULER: "readinessRuler",
	IMPORTANCE_RULER: "importanceRuler",
	WALL_QUESTION: "wallQuestion",
	IMPORTANCE_CONFIDENCE_READINESS_CHECK: "importanceConfidenceReadinessCheck",
	CONCERNS_CHECKLIST: "concernsChecklist",
	DBT_SKILLS_DIARY_CARD: "dbtSkillsDiaryCard",
	NIDA_DIARY_CARD: "nidaDiaryCard",
	MOOD_DIARY: "moodDiary",
	SELF_MONITORING_FORM: "selfMonitoringForm",
	MOMENTARY_TIME_SAMPLING: "momentaryTimeSampling",
	SUBJECTIVE_UNITS_OF_DISTRESS_SCALE_SUDS: "subjectiveUnitsOfDistressScaleSuds",
	VALUES_BULLSEYE: "valuesBullseye",
	VALUES_CARD_SORT: "valuesCardSort",
	DBT_CHAIN_ANALYSIS: "dbtChainAnalysis",
	DBT_SOLUTION_ANALYSIS: "dbtSolutionAnalysis",
	MISSING_LINKS_ANALYSIS: "missingLinksAnalysis",
	LINEHAN_RISK_ASSESSMENT_AND_MANAGEMENT_PROTOCOL_LRAMP: "linehanRiskAssessmentAndManagementProtocolLramp",
	IMMINENT_RISK_AND_ACTION_PLAN: "imminentRiskAndActionPlan",
	CY_BOCS: "childrenSYaleBrownObsessiveCompulsiveScaleCyBocs",
	CY_BOCS_II: "childrenSYaleBrownObsessiveCompulsiveScaleSecondEditionCyBocsIi",
	COIS_R: "childObsessiveCompulsiveImpactScaleRevisedCoisR",
	PATIENT_EX_RP_ADHERENCE_SCALE_PEAS: "patientExRpAdherenceScalePeas",
	SCHEMA_MODE_INVENTORY: "schemaModeInventorySmi11ShortSmi",
	YOUNG_SCHEMA_QUESTIONNAIRE_L3: "youngSchemaQuestionnaireLongForm3rdEditionYsqL3",
	OCI_CV: "obsessiveCompulsiveInventoryChildVersionOciCv",
	LIFETIME_SUICIDE_ATTEMPT_SELF_INJURY_COUNT_L_SASI: "lifetimeSuicideAttemptSelfInjuryCountLSasi",
	CAREER_CONSTRUCTION_INTERVIEW: "careerConstructionInterviewCci",
	INTERPERSONAL_INVENTORY: "interpersonalInventory",
	SYSTEMATIC_EVOCATIVE_UNFOLDING: "systematicEvocativeUnfolding",
	PATTERNS_OF_PROBLEMATIC_THINKING_WORKSHEET: "patternsOfProblematicThinkingWorksheet",
	IMPACT_STATEMENT: "impactStatement",
	GRADED_TASK_ASSIGNMENT: "gradedTaskAssignment",
	CCI_GRADED_TASKS_AND_EXPOSURE: "cciGradedTasksAndGradedExposureWorksheet",
	STATEMENT_OF_POSITION_MAP: "statementOfPositionMap",
	MOHOST: "mohost",
	OCAIRS: "ocairs",
})
